import { buildColumnTypeMap, cellTypeForColumn } from '../../reporting-core/column-types';
import { ReportCellType } from '../../reporting-core/cell-format';
import { escapeHtml, renderStandardCell, ReportRenderConfig } from '../../reporting-core/cell-html';
import { Customer } from '../customer';
import { getContentItem } from '../exports/customers';
import {
  COLUMN_NAME_ID,
  COLUMN_NAME_FIRST_NAME,
  COLUMN_NAME_LAST_NAME,
  COLUMN_NAME_PREFERRED_NAME,
  COLUMN_NAME_BIRTHDAY,
  COLUMN_NAME_AGE,
  COLUMN_NAME_EMAIL_ADDRESS,
  COLUMN_NAME_EMAIL_OPT_IN,
  COLUMN_NAME_ADDRESS_POSTCODE,
  COLUMN_NAME_ADDRESS_STREET_1,
  COLUMN_NAME_ADDRESS_STREET_2,
  COLUMN_NAME_ADDRESS_CITY,
  COLUMN_NAME_ADDRESS_STATE,
  COLUMN_NAME_ADDRESS_COUNTRY,
  COLUMN_NAME_TELEPHONE,
  COLUMN_NAME_GOVT_ID_NUMBER,
  COLUMN_NAME_GENDER,
  COLUMN_NAME_PRONOUNS,
  COLUMN_NAME_BARCODE,
  COLUMN_NAME_CHECK_IN_COUNT,
  COLUMN_NAME_HAS_ACTIVE_MEMBERSHIP,
  COLUMN_NAME_HAS_ACTIVE_YOUTH_PROGRAMMING_MEMBERSHIP,
  COLUMN_NAME_HAS_ACTIVE_NON_YOUTH_PROGRAMMING_MEMBERSHIP,
  COLUMN_NAME_HAS_MEMBERSHIP_WITH_FUTURE_START,
  COLUMN_NAME_HAS_FROZEN_MEMBERSHIP,
  COLUMN_NAME_NUMBER_OF_AVAILABLE_ENTRY_PASSES,
  COLUMN_NAME_ACTIVE_WAIVER_EXISTS,
  COLUMN_NAME_LATEST_WAIVER_EXPIRATION_DATE,
  COLUMN_NAME_ACTIVE_PROFICIENCY_NAMES,
  COLUMN_NAME_FIRST_CHECK_IN_TIMESTAMP,
  COLUMN_NAME_LATEST_CHECK_IN_TIMESTAMP,
  COLUMN_NAME_DAYS_SINCE_LATEST_CHECK_IN,
  COLUMN_NAME_FIRST_MEMBERSHIP_TIMESTAMP,
  COLUMN_NAME_ACCOUNT_CREATED_TIMESTAMP,
  COLUMN_NAME_HOME_LOCATION_ID,
  COLUMN_NAME_HOME_LOCATION_NAME,
  COLUMN_NAME_CHECK_IN_COUNT_IN_RANGE,
} from '../exports/customers';

export {
  COLUMN_NAME_ID,
  COLUMN_NAME_FIRST_NAME,
  COLUMN_NAME_LAST_NAME,
  COLUMN_NAME_PREFERRED_NAME,
  COLUMN_NAME_BIRTHDAY,
  COLUMN_NAME_AGE,
  COLUMN_NAME_EMAIL_ADDRESS,
  COLUMN_NAME_EMAIL_OPT_IN,
  COLUMN_NAME_ADDRESS_POSTCODE,
  COLUMN_NAME_ADDRESS_STREET_1,
  COLUMN_NAME_ADDRESS_STREET_2,
  COLUMN_NAME_ADDRESS_CITY,
  COLUMN_NAME_ADDRESS_STATE,
  COLUMN_NAME_ADDRESS_COUNTRY,
  COLUMN_NAME_TELEPHONE,
  COLUMN_NAME_GOVT_ID_NUMBER,
  COLUMN_NAME_GENDER,
  COLUMN_NAME_PRONOUNS,
  COLUMN_NAME_BARCODE,
  COLUMN_NAME_CHECK_IN_COUNT,
  COLUMN_NAME_HAS_ACTIVE_MEMBERSHIP,
  COLUMN_NAME_HAS_ACTIVE_YOUTH_PROGRAMMING_MEMBERSHIP,
  COLUMN_NAME_HAS_ACTIVE_NON_YOUTH_PROGRAMMING_MEMBERSHIP,
  COLUMN_NAME_HAS_MEMBERSHIP_WITH_FUTURE_START,
  COLUMN_NAME_HAS_FROZEN_MEMBERSHIP,
  COLUMN_NAME_NUMBER_OF_AVAILABLE_ENTRY_PASSES,
  COLUMN_NAME_ACTIVE_WAIVER_EXISTS,
  COLUMN_NAME_LATEST_WAIVER_EXPIRATION_DATE,
  COLUMN_NAME_ACTIVE_PROFICIENCY_NAMES,
  COLUMN_NAME_FIRST_CHECK_IN_TIMESTAMP,
  COLUMN_NAME_LATEST_CHECK_IN_TIMESTAMP,
  COLUMN_NAME_DAYS_SINCE_LATEST_CHECK_IN,
  COLUMN_NAME_FIRST_MEMBERSHIP_TIMESTAMP,
  COLUMN_NAME_ACCOUNT_CREATED_TIMESTAMP,
  COLUMN_NAME_HOME_LOCATION_ID,
  COLUMN_NAME_HOME_LOCATION_NAME,
  COLUMN_NAME_CHECK_IN_COUNT_IN_RANGE,
};

export const COLUMN_HEADER_OVERRIDES: {[key: string]: string} = {
  [COLUMN_NAME_CHECK_IN_COUNT_IN_RANGE]: '# Check-Ins in Range',
};

const PRIMARY_COLUMN_NAMES: string[] = [
  COLUMN_NAME_ID,
  COLUMN_NAME_FIRST_NAME,
  COLUMN_NAME_LAST_NAME,
  COLUMN_NAME_PREFERRED_NAME,
  COLUMN_NAME_BIRTHDAY,
  COLUMN_NAME_AGE,
  COLUMN_NAME_EMAIL_ADDRESS,
  COLUMN_NAME_EMAIL_OPT_IN,
  COLUMN_NAME_ADDRESS_POSTCODE,
  COLUMN_NAME_ADDRESS_STREET_1,
  COLUMN_NAME_ADDRESS_STREET_2,
  COLUMN_NAME_ADDRESS_CITY,
  COLUMN_NAME_ADDRESS_STATE,
  COLUMN_NAME_ADDRESS_COUNTRY,
  COLUMN_NAME_TELEPHONE,
  COLUMN_NAME_GOVT_ID_NUMBER,
  COLUMN_NAME_GENDER,
  COLUMN_NAME_PRONOUNS,
  COLUMN_NAME_BARCODE,
  COLUMN_NAME_CHECK_IN_COUNT,
  COLUMN_NAME_HAS_ACTIVE_MEMBERSHIP,
  COLUMN_NAME_HAS_ACTIVE_YOUTH_PROGRAMMING_MEMBERSHIP,
  COLUMN_NAME_HAS_ACTIVE_NON_YOUTH_PROGRAMMING_MEMBERSHIP,
  COLUMN_NAME_HAS_MEMBERSHIP_WITH_FUTURE_START,
  COLUMN_NAME_HAS_FROZEN_MEMBERSHIP,
  COLUMN_NAME_NUMBER_OF_AVAILABLE_ENTRY_PASSES,
  COLUMN_NAME_ACTIVE_WAIVER_EXISTS,
  COLUMN_NAME_LATEST_WAIVER_EXPIRATION_DATE,
  COLUMN_NAME_ACTIVE_PROFICIENCY_NAMES,
  COLUMN_NAME_FIRST_CHECK_IN_TIMESTAMP,
  COLUMN_NAME_LATEST_CHECK_IN_TIMESTAMP,
  COLUMN_NAME_DAYS_SINCE_LATEST_CHECK_IN,
  COLUMN_NAME_FIRST_MEMBERSHIP_TIMESTAMP,
  COLUMN_NAME_ACCOUNT_CREATED_TIMESTAMP,
  COLUMN_NAME_HOME_LOCATION_ID,
  COLUMN_NAME_HOME_LOCATION_NAME,
];

export const REPORT_COLUMN_NAMES_PRIMARY: string[] = [
  ...PRIMARY_COLUMN_NAMES,
];

export const REPORT_COLUMN_NAMES_CHECK_IN_RANGE: string[] = [
  COLUMN_NAME_CHECK_IN_COUNT_IN_RANGE,
  ...PRIMARY_COLUMN_NAMES,
];

export const DEFAULT_COLUMNS_PRIMARY: string[] = [
  COLUMN_NAME_FIRST_NAME,
  COLUMN_NAME_LAST_NAME,
  COLUMN_NAME_EMAIL_ADDRESS,
  COLUMN_NAME_AGE,
  COLUMN_NAME_BIRTHDAY,
];

export const DEFAULT_COLUMNS_CHECK_IN_RANGE: string[] = [
  COLUMN_NAME_FIRST_NAME,
  COLUMN_NAME_LAST_NAME,
  COLUMN_NAME_CHECK_IN_COUNT_IN_RANGE,
];

// Columns whose data is present in the /customer-search/ payload. When the
// user has an active search filter the Customers list falls back to that
// endpoint (for its barcode/telephone exact-match fast-paths), and columns
// outside this set render empty.
export const SEARCH_RESULT_AVAILABLE_COLUMNS: string[] = [
  COLUMN_NAME_ID,
  COLUMN_NAME_FIRST_NAME,
  COLUMN_NAME_LAST_NAME,
  COLUMN_NAME_PREFERRED_NAME,
  COLUMN_NAME_BIRTHDAY,
  COLUMN_NAME_AGE,
  COLUMN_NAME_EMAIL_ADDRESS,
];

export const COLUMN_TYPES = buildColumnTypeMap({
  [ReportCellType.objectId]: [
    COLUMN_NAME_ID,
    COLUMN_NAME_HOME_LOCATION_ID,
  ],
  [ReportCellType.date]: [
    COLUMN_NAME_BIRTHDAY,
    COLUMN_NAME_LATEST_WAIVER_EXPIRATION_DATE,
    COLUMN_NAME_FIRST_CHECK_IN_TIMESTAMP,
    COLUMN_NAME_LATEST_CHECK_IN_TIMESTAMP,
    COLUMN_NAME_FIRST_MEMBERSHIP_TIMESTAMP,
    COLUMN_NAME_ACCOUNT_CREATED_TIMESTAMP,
  ],
  [ReportCellType.custom]: [
    COLUMN_NAME_FIRST_NAME,
    COLUMN_NAME_LAST_NAME,
  ],
});

/**
 * The HTML shown for a column in the report table, for the emailed report.
 * Mirrors the on-screen rendering (customers.component.html): the First name and
 * Last name custom cells; everything else is a standard cell. Returns null-safe
 * escaped HTML.
 */
export function getDisplayText(customer: Customer, column: string, config: ReportRenderConfig): string {
  switch (column) {
    case COLUMN_NAME_FIRST_NAME: {
      let html = customer.first_name
        ? escapeHtml(customer.first_name)
        : '<span class="text-secondary">None</span>';
      if (customer.preferred_name && customer.preferred_name !== customer.first_name) {
        html += ' <span>"' + escapeHtml(customer.preferred_name) + '"</span>';
      }
      return html;
    }
    case COLUMN_NAME_LAST_NAME:
      return customer.last_name
        ? escapeHtml(customer.last_name)
        : '<span class="text-secondary">None</span>';
    default:
      return renderStandardCell(getContentItem(customer, column), cellTypeForColumn(COLUMN_TYPES, column), config);
  }
}
